import React from 'react';
import Icon from '../../../components/AppIcon';

const OnboardingHeader = ({ currentStep, totalSteps, onBack }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={onBack}
          className="p-2 hover:bg-muted rounded-lg transition-colors"
          aria-label="Go back"
        >
          <Icon name="ArrowLeft" size={24} color="var(--color-foreground)" />
        </button>
        <div className="text-sm font-medium text-muted-foreground">
          Step {currentStep} of {totalSteps}
        </div>
      </div>
      <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-300 ease-out"
          style={{
            width: `${progress}%`,
            background: 'linear-gradient(90deg, var(--color-primary) 0%, var(--color-accent) 100%)'
          }}
        />
      </div>
    </div>
  );
};

export default OnboardingHeader;